import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { BehaviorSubject, catchError, Observable, of, throwError } from 'rxjs';
import { User } from '../models/user.model';
import { Login } from '../models/login.model';
import { environment } from 'src/environments/environment';
import * as utils from '../../shared/helpers/utils';
import { GazeMapService } from './gaze-map.service';
import { PaginationService } from './pagination.service';
import { FitService } from './fit.service';
import { LicenseService } from './license.service';
import { ConfigService } from './config.service';
import { EntityService } from './entity.service';
import { SettingsService } from './settings.service';

@Injectable({
  providedIn: 'root'
})
export class LoginService {

  userStore = new BehaviorSubject(new User());

  constructor(
    private httpClient: HttpClient,
    private router: Router,
    private gazeMapService: GazeMapService,
    private fitService: FitService,
    private dynamoPaginationService: PaginationService,
    private licenseService: LicenseService,
    private configSvc: ConfigService,
    private entityService: EntityService
  ) { }

  login(data: FormGroup): Observable<Login> {
    return this.httpClient.post<Login>(environment.apiUrl + '/login', data)
    //.pipe(catchError(this.handleError));
  }
  private handleError(error: HttpErrorResponse) {
    return throwError(() => error);
  }

  refresh(refreshToken: string) {
    return this.httpClient.post<any>(environment.cognitoUrl + '/login', { 'refresh_token': refreshToken })
  }

  passwordForgotten(email: string) {
    return this.httpClient.post<any>(environment.cognitoUrl + '/reset-password', { 'user': email })
  }

  changePassword(action: string, body: any) {
    return this.httpClient.post<any>(environment.cognitoUrl + '/' + action, body)
  }

  resendValidation(email: string) {
    return this.httpClient.post<any>(environment.cognitoUrl + '/resend-validation', { email })
  }

  logOut() {

    //clear config
    this.configSvc.clear();
    this.entityService.clearEntityAppsCache();
    this.licenseService.setCurrentPackageParamConfig('pagination', null);
    this.licenseService.setCurrentPackageParamConfig('partners', null);
    this.licenseService.setCurrentPackageParamConfig('shops_selected', null);
    this.dynamoPaginationService.resetGazeMapPagination();
    localStorage.removeItem('mimesysFilter');
    this.gazeMapService.setCurrentGazeMapParamConfig('pagination', null);
    this.gazeMapService.setCurrentGazeMapParamConfig('partners', null);
    this.gazeMapService.setCurrentGazeMapParamConfig('shops_selected', null);
    this.dynamoPaginationService.resetGazeMapPagination();
    localStorage.removeItem('fitFilter');
    this.fitService.setCurrentFitParamConfig('pagination', null);
    this.fitService.setCurrentFitParamConfig('partners', null);
    this.fitService.setCurrentFitParamConfig('shops_selected', null);
    this.router.navigate(['login'], { queryParams: { 'loginToken': utils.localStorageGetItem('loginToken') } })
    localStorage.clear();
  }

}
